import React, { Component } from 'react';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import SendIcon from '@material-ui/icons/Send';
import MoodIcon from '@material-ui/icons/Mood';
import MoodTwoToneIcon from '@material-ui/icons/MoodTwoTone';
import 'emoji-mart/css/emoji-mart.css';
import { Picker } from 'emoji-mart';
//import { toImage } from 'emoji-toolkit/lib/js/joypixels';
import 'emoji-toolkit/extras/css/joypixels.css';

import windowActions from '../actions/window_actions';
import { ensureEmojiFontFace, composeFontFamily } from '../utils/emojiInputFont';

import '../../src/index.css';

// The compose bar is position:fixed at bottom:0 with a fixed height, and
// ChatBoxMessageList pins itself to 92px off the same bottom edge to leave
// room for it. So the bar cannot grow: a multiline TextField that gets taller
// than this has nowhere to put the extra rows except past the bottom of the
// window, where they are clipped by the window frame rather than by anything
// that scrolls. Typing a long paragraph took the caret down there with them.
//
// COMPOSE_ROWS is what the bar was sized for - 3 rows of the 16px lineHeight
// set in inputProps below - and it is both the floor and the ceiling. At the
// ceiling TextareaAutosize stops setting a height and lets the textarea
// scroll instead, so the caret stays inside the bar however long the message
// gets. Change one of these and the other two have to follow.
export const COMPOSE_ROWS = 3;
export const COMPOSE_BAR_HEIGHT = 80;

export class ChatBoxCompose extends Component {
    constructor(props) {
        super(props);
        this.state = {
            messages: this.props.messages, // messages passed down from ChatBoxWindow parent
            sendMessage: "",
            showEmoji: false,
        };
        this.pickerRef = React.createRef();
        this.emojiButtonRef = React.createRef();
        // The document the picker is actually in, held from the moment it
        // opens so the listeners can be taken off the same one they went on.
        this.dismissDocument = null;
    }

    // The emoji face has to be installed in the document the input is in, and
    // the chat is a detached window - so it goes through a ref's ownerDocument
    // for the same reason the picker's dismiss listeners do. The button is the
    // one node here that is always rendered.
    componentDidMount() {
        const button = this.emojiButtonRef.current;
        if (button) {
            ensureEmojiFontFace(button.ownerDocument);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.showEmoji === prevState.showEmoji) {
            return;
        }
        if (this.state.showEmoji) {
            this.listenForDismiss();
        } else {
            this.stopListeningForDismiss();
        }
    }

    // Six tab panels each hold one of these and they all render, so a
    // listener left behind outlives its window.
    componentWillUnmount() {
        this.stopListeningForDismiss();
    }

    // The chat renders in a detached window, so the `document` this module
    // closes over is the opener's - the wrong one. Ask the picker which
    // document it is in.
    listenForDismiss = () => {
        const picker = this.pickerRef.current;
        if (!picker) {
            return;
        }
        this.dismissDocument = picker.ownerDocument;
        this.dismissDocument.addEventListener('mousedown', this.handleDismissMouseDown);
        this.dismissDocument.addEventListener('keydown', this.handleDismissKeyDown);
    };

    stopListeningForDismiss = () => {
        if (!this.dismissDocument) {
            return;
        }
        this.dismissDocument.removeEventListener('mousedown', this.handleDismissMouseDown);
        this.dismissDocument.removeEventListener('keydown', this.handleDismissKeyDown);
        this.dismissDocument = null;
    };

    handleDismissMouseDown = (event) => {
        const picker = this.pickerRef.current;
        const button = this.emojiButtonRef.current;
        if (picker && picker.contains(event.target)) {
            return;
        }
        // mousedown lands before click. Closing here on the button's own press
        // would let its click reopen the picker, so the button would appear to
        // do nothing and the picker would look stuck open.
        if (button && button.contains(event.target)) {
            return;
        }
        this.setState({ showEmoji: false });
    };

    handleDismissKeyDown = (event) => {
        if (event.key === 'Escape') {
            this.setState({ showEmoji: false });
        }
    };

    /*
    Given string "Hi :grinning: how are you?".
    Return "Hi :) how are you?"
    
    var allEmojisObj = [{id: "grinning", name: "Grinning Face", short_names: ["grinning"], skin: null, unified: "1f600", colons: ":grinning:", native: ":)", emoticons: []}, {...}, {...}, ...];
    
      convertColonsToEmoji = (messageToBeSent) => {
        //iterate through message
        //if message includes ":emojiId:"
          //iterate through every emoji object
            //if :emojiId: is a value for the "colons" property
              //then grab that emoji object's "native" property
            //else do nothing
        //else do nothing
      };
     */

    sendMessage = () => {
        var tempMessages = this.state.messages.slice();
        tempMessages.push({ isOwner: true, message: this.state.sendMessage });
        this.setState({ messages: tempMessages, sendMessage: "" });
        this.props.callbackFromParent({ userId: this.props.profile.id, createAt: (new Date().getTime()), message: this.state.sendMessage });
    };

    handleClickSendMessage = (e) => {
        if (this.state.sendMessage !== "") {
            //this.convertColonsToEmoji(this.state.sendMessage);
            this.sendMessage();
        }
    };

    handleEnterSendMessage = (e) => {
        if (e.key === "Enter" && this.state.sendMessage !== "") {
            e.preventDefault();
            //this.convertColonsToEmoji(this.state.sendMessage);
            this.sendMessage();
        }
    };

    //getCurrentTime = () => {
    //  var today = new Date();
    //  var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    //  var time = today.getHours() + ":" + today.getMinutes();
    //  var dateTime = date + ' ' + time;
    //  return dateTime;
    //}

    handleChange = property => event => {
        this.props.unreadCallback();
        // Let the parent tell the recipient something is coming. Only while
        // there is something to send: emptying the box is how you stop
        // composing, and it should read that way on the other end.
        if (typeof this.props.typingCallback === 'function' && event.target.value !== "") {
            this.props.typingCallback();
        }
        var tempState = {};
        tempState[property] = event.target.value;
        this.setState(tempState);
    };

    handleShowEmoji = () => {
        this.setState({ showEmoji: !this.state.showEmoji });
    };

    addEmoji = (e) => {
        let emoji = e.native;
        this.setState({
            sendMessage: this.state.sendMessage + emoji,
            showEmoji: false
        })
    };

    render() {
        let emojiPicker;
        let emojiButton;

        if (this.state.showEmoji) {
            // The positioning moves to a wrapper so there is a node of our own
            // to ask "did the click land inside?" - Picker gives us no ref.
            emojiPicker =
                <div ref={this.pickerRef} style={{ position: 'absolute', bottom: '70px', right: '10px' }}>
                    <Picker
                        set='messenger'
                        title='Pick emoji'
                        emoji='point_up'
                        perLine={8}
                        onSelect={this.addEmoji}
                        showSkinTones={false}
                    />
                </div>;
        }

        if (this.state.showEmoji) {
            emojiButton = <MoodTwoToneIcon style={{ fontSize: '2.5rem', color: '#3f51b5' }} />;
        } else {
            emojiButton = <MoodIcon style={{ fontSize: '2.5rem' }} />;
        }

        return (

            <Grid container item xs={12} spacing={0} style={{ position: 'fixed', bottom: '0', height: COMPOSE_BAR_HEIGHT + 'px' }}>

                <Grid item xs={11}>
                    {/* The text is 14px, up from 13. lineHeight stays at 16px:
                        the bar is COMPOSE_BAR_HEIGHT and capped at
                        COMPOSE_ROWS of those lines, so changing it would
                        change how many rows fit. composeFontFamily leads with
                        the emoji face, which is what draws emoji - and only
                        emoji - larger still. */}
                    <TextField
                        autoFocus
                        ref={(ip) => this.myInput = ip}
                        id="outlined-multiline-static"
                        placeholder="Write a message..."
                        fullWidth
                        multiline
                        minRows={COMPOSE_ROWS}
                        maxRows={COMPOSE_ROWS}
                        margin="normal"
                        variant="outlined"
                        inputProps={{ style: { fontSize: '14px', fontFamily: composeFontFamily, padding: '0px', margin: '-5px', lineHeight: '16px' } }}
                        style={{ marginLeft: '10px', backgroundColor: 'white', marginTop: '-4px', paddingRight: '22px' }}
                        value={this.state.sendMessage}
                        onChange={this.handleChange('sendMessage')}
                        onKeyPress={this.handleEnterSendMessage}
                    />
                </Grid>

                <Grid container item xs={1} spacing={0}>

                    <Grid item xs={12} style={{}}>
                        <IconButton ref={this.emojiButtonRef} title={'Emojis'} onClick={this.handleShowEmoji} style={{ backgroundColor: 'white', padding: '0px', marginTop: '6px' }}>
                            {emojiButton}
                        </IconButton>
                    </Grid>

                    <Grid item xs={12} style={{ paddingBottom: '25px' }}>
                        <IconButton title={'Send Message'} onClick={this.handleClickSendMessage} style={{ backgroundColor: 'white', padding: '0px', marginTop: '6px' }}>
                            <SendIcon style={{ fontSize: '2.5rem' }} />
                        </IconButton>
                    </Grid>

                </Grid>
                {emojiPicker}
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    return {
        members: state.members,
        profile: state.profile,
        currentUser: state.currentUser,
        shouldTurnFlashOn: state.shouldTurnFlashOn,
    };
}

const mapDispatchToProps = dispatch => ({
    setIconFlash: shouldTurnFlashOn => dispatch(windowActions['SET_ICON_FLASH'](shouldTurnFlashOn)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ChatBoxCompose);


// WEBPACK FOOTER //
// ./src/components/ChatBoxCompose.js


// WEBPACK FOOTER //
// ./src/components/ChatBoxCompose.js